import { useMemo } from 'react';

const useIsDev = () => {
  const isDevEnvironment = useMemo(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    const isDevMode = process.env.NODE_ENV === 'development';

    const isDevHost =
      window.location.host.search('dev.jetshop.se') !== -1 ||
      window.location.host.search('localhost') !== -1;

    return isDevMode || isDevHost;
  }, []);

  return isDevEnvironment;
};

export default useIsDev;
